<template>
    <q-dialog v-model="showDialog" class="consent-dialog">
        <q-card>
            <q-card-section>
                <h5 class="consent-header">Privacy Consent</h5>
            </q-card-section>

            <q-separator />

            <q-card-section style="max-height: 50vh" class="scroll">
                <p>
                    I agree that any information I provide may be used for the purposes of case management and review,
                    including continuous assessment of risk and wellbeing. This information will be accessed by staff
                    directly involved with my care only.
                    Non-identifiable data will be used to assist Purapura Whetu Trust to improve their services.
                    I understand that my data will be held securely, will not be distributed to third parties without
                    prior consultation, and that I have rights under Privacy Act 2020 to access, change, and receive
                    further detail on how my data is being used.
                    I understand that when this information is no longer required for the agreed purposes, it will be
                    disposed of securely.
                </p>
            </q-card-section>

            <q-separator />

            <q-card-actions class="consent-button-container" align="center">
                <q-btn size="16px" outline flat no-caps rounded label="Decline" color="teal" v-close-popup />
                <q-btn size="16px" outline flat no-caps rounded label="Accept" color="teal"
                    @click="$emit('consent-given')" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
    export default {
        name: "FormConsentDialog",
        emits: ['update:show', 'consent-given'],
        props: {
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                showDialog: this.prompt
            }
        },
        watch: {
            show(newVal) {
                this.showDialog = newVal;
            },
            showDialog(newVal) {
                this.$emit('update:show', newVal);
            }
        },
    }
</script>